<ng-container *ngrxLet="modalData.component$ as component">
	@if (component) {
		<ng-container
			[ngTemplateOutlet]="core"
			[ngTemplateOutletContext]="{ component: component }"
		/>
	} @else {
		<ng-container *ngTemplateOutlet="core; context: null" />
	}
</ng-container>

<ng-template #core let-component="component">
	<div *nzModalTitle>
		<span class="text-base md:text-lg lg:text-lg">
			{{ modalData.title }}
		</span>
		@if (modalData.subTitle) {
			@if (isArray(modalData.subTitle)) {
				<fms-chip>
					@for (
						elem of modalData.subTitle;
						track elem;
						let last = $last
					) {
						{{ elem }}
						@if (!last) {
							<nz-divider nzType="vertical" />
						}
					}
				</fms-chip>
			} @else {
				<fms-chip>{{ modalData.subTitle }}</fms-chip>
			}
		}
	</div>
	<fms-vimeo-player
		[playerOptions]="{ id: modalData.videoId, autoplay: true }"
	/>
	@if (component?.aboveFoldContent) {
		<div class="p-4">
			<div class="text-lg font-bold">
				{{
					modalData.textContentTitle
						? modalData.textContentTitle
						: 'Om'
				}}
			</div>
			<div>
				<p>{{ component?.aboveFoldContent }}</p>
				@if (showBelowFold) {
					<p>{{ component?.belowFoldContent }}</p>
				}
				@if (component?.belowFoldContent) {
					<fms-button (click)="toggleBelowFoldContent()">
						{{ showBelowFold ? 'Læs mindre' : 'Læs mere' }}
					</fms-button>
				}
			</div>
		</div>
	}
	<div *nzModalFooter class="h-12">
		@if (component) {
			<fms-toggle-favorite-button
				[hidden]="modalData.hideFavoriteBtn"
				class="float-left"
				mode="button"
				[componentId]="component.id"
				[actionId]="component?.favoriteAction?.id"
			/>
		}
		<fms-button class="float-right" (click)="closeModal()">
			<span class="mr-2">
				<svg
					class="h-6 opacity-50"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M5 13l4 4L19 7"
					/>
				</svg>
			</span>
			Luk
		</fms-button>
	</div>
</ng-template>
